import { connect } from 'react-redux'
import BenefitIllustration from '../../../components/benefit-illustration/container'

import { isBlockedEnteringESub } from 'quick-quote/selectors'
import { getMenus, getSections } from './selectors'

const getSectionByProductCode = (state) => {
  return getSections(state)
}

const getMenuByProductCode = (state) => {
  return getMenus(state)
}

const mapStateToProps = (state) => ({
  sections: getSectionByProductCode(state),
  menus: getMenuByProductCode(state),
  isBlockedEnteringESub: isBlockedEnteringESub(state),
})

const mapDispatchToProps = () => ({})

export const BenefitIllustrationContainer = connect(mapStateToProps, mapDispatchToProps)(BenefitIllustration)
